import { Client, NickEvent, NickInUseEvent, NickInvalidEvent } from 'irc-framework';
import { InterfaceTab, IRC_EVENT, IRCMessageType } from '#/types/types';
import { updateNickname } from '#/util/settings';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class NickEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.NICK, (event: NickEvent) => {
            const { nick, ident, hostname, new_nick, time, account, tags, batch } = event;
            const ourNick = this.client?.user.nick;

            if (nick === ourNick) {
                const nickInput = document.getElementById('irc-nickname') as HTMLInputElement;
                if (nickInput) { nickInput.value = new_nick; }
                updateNickname(new_nick);
            }
            const channelTabs = this.tM.getAllChannelTabs();
            channelTabs.forEach((tab: InterfaceTab) => {
                this.cH.refreshUserList(tab.name);
                this.mH.addMessage(tab, `* ${nick} is now known as ${new_nick}`, IRCMessageType.SYSTEM);
            });
        });

        this.client.on(IRC_EVENT.NICK_IN_USE, (event: NickInUseEvent) => {
            const { nick, reason } = event;
            const rndDigit1 = Math.floor(Math.random() * 10);
            const rndDigit2 = Math.floor(Math.random() * 10);
            const rndDigit3 = Math.floor(Math.random() * 10);
            const rndDigit4 = Math.floor(Math.random() * 10);
            const newNick = nick + `${rndDigit1}${rndDigit2}${rndDigit3}${rndDigit4}`;
            this.mH.addMessage(this.tM.getStatusTab(), `Nickname ${nick} is already in use. Changing to ${newNick}...`, IRCMessageType.ERROR);
            this.cH.sendIRCCommand('NICK', newNick);
        });

        this.client.on(IRC_EVENT.NICK_INVALID, (event: NickInvalidEvent) => {
            const { nick, reason } = event;
            this.mH.addMessage(this.tM.getStatusTab(), `Erroneous nickname ${nick} (${reason})`, IRCMessageType.ERROR);
        });
    }
}